import { FeatureFlagsContext } from "components/providers/featureFlags/featureFlagContext";
import { useContext } from "react";

export const useFeatureFlags = () => {
    const [enabled] = useContext(FeatureFlagsContext);
    return enabled;
};

export const useSetFeatureFlags = () => {
    const [, setState] = useContext(FeatureFlagsContext);
    return {
        toggle: () => setState(prev => !prev),
        enable: () => setState(true),
        disable: () => setState(false),
    };
};
